const types = {
  LOOK_UP_DATA: "LOOK_UP_DATA",
};
export default types;
